"use client";

import { RiCloseLine, RiSearchLine } from "@remixicon/react";
import { Kbd } from "@workspace/ui/components/kbd";

export interface SearchModalInputProps {
	value: string;
	onChange: (value: string) => void;
	onClose: () => void;
	inputRef?: React.RefObject<HTMLInputElement | null>;
	isMobile?: boolean;
}

export function SearchModalInput({
	value,
	onChange,
	onClose,
	inputRef,
	isMobile = false,
}: SearchModalInputProps) {
	return (
		<div
			className="flex items-center border-border/50 border-b bg-muted/30 p-4"
			style={{ paddingTop: "calc(env(safe-area-inset-top) + 1rem)" }}
		>
			<RiSearchLine className="mr-2 h-4 w-4 flex-shrink-0 text-muted-foreground" />
			<input
				ref={inputRef}
				type="text"
				placeholder="Search festivals, shows, artists, members..."
				className="flex-1 border-none bg-transparent text-foreground outline-none"
				value={value}
				onChange={(e) => onChange(e.target.value)}
			/>
			{!isMobile && (
				<Kbd className="mx-2 hidden flex-shrink-0 md:block">
					Esc
				</Kbd>
			)}
			<button
				type="button"
				onClick={onClose}
				className="flex-shrink-0 text-muted-foreground hover:text-foreground"
				aria-label="Close"
			>
				<RiCloseLine className="h-4 w-4" />
			</button>
		</div>
	);
}
